import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './kpi-last-processed.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const KpiLastProcessedDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const kpiLastProcessedEntity = useAppSelector(state => state.kpiLastProcessed.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="kpiLastProcessedDetailsHeading">
          <Translate contentKey="fleetSenseApp.kpiLastProcessed.detail.title">KpiLastProcessed</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{kpiLastProcessedEntity.id}</dd>
          <dt>
            <span id="sensorData">
              <Translate contentKey="fleetSenseApp.kpiLastProcessed.sensorData">Sensor Data</Translate>
            </span>
          </dt>
          <dd>{kpiLastProcessedEntity.sensorData}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.kpiLastProcessed.truckImplement">Truck Implement</Translate>
          </dt>
          <dd>{kpiLastProcessedEntity.truckImplement ? kpiLastProcessedEntity.truckImplement.licensePlate : ''}</dd>
        </dl>
        <Button tag={Link} to="/kpi-last-processed" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/kpi-last-processed/${kpiLastProcessedEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default KpiLastProcessedDetail;
